var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var FeaturedPlacement = createReactClass({
    mixins: [PureRenderMixin],

	render: function(){
        var adNode = null;

        if(this.props.placement.width){
            if(this.props.placement.body){
                adNode = (
                    <div dangerouslySetInnerHTML={{__html: this.props.placement.body}}></div>
                );
            }else{
                adNode = (
                    <a href={this.props.placement.redirect_url} target={this.props.placement.target || '_blank'}>
                        <img src={this.props.placement.image_url} width={this.props.placement.width} height={this.props.placement.height} alt={this.props.placement.alt_text} />
                    </a>
                );
            }
        }


		return (
            <div className="ad-banner">
                {this.props.placement.tracking_pixel &&
                    <img className="hide" src={this.props.placement.tracking_pixel} alt="" />
                }
                <div className="ad-banner-outer-frame">
                    <div className="ad-banner-inner-frame" style={{paddingTop: this.props.placement.height/this.props.placement.width * 100 + '%'}}>
                        {adNode}
                    </div>
                </div>
            </div>
	    )
	}
});

module.exports = FeaturedPlacement;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/featuredPlacement.jsx